import { Tooltip } from '@fullstory/components';
import { noPermissionMessage } from '../../utils';
import React, { ComponentProps } from 'react';
import { useIntl } from 'react-intl';

type ViewOnlyTooltipProps = Omit<ComponentProps<typeof Tooltip>, 'tooltipContent' | 'compact'> & {
  isViewOnly?: boolean;
  tooltipContent?: React.ReactNode;
};

export const ViewOnlyTooltip: React.FC<ViewOnlyTooltipProps> = ({
  children,
  isViewOnly,
  tooltipContent,
  ...rest
}) => {
  const intl = useIntl();

  return (
    <Tooltip
      {...rest}
      disabled={!isViewOnly}
      tooltipContent={tooltipContent ?? intl.formatMessage(noPermissionMessage)}
    >
      {children}
    </Tooltip>
  );
};
